import React, { useState } from 'react'
import type { BerthGroup } from 'repositories/BerthApi/getBerthGroups/type'

import { Berth } from '../../types'
import { Select } from '../Select'

import styles from './index.module.css'

type Props = {
  berths: Berth[]
  berthGroups: BerthGroup[]
  selectedBerthId: string | null
  onChange: (berthId: string) => void
  isBerthNotFound?: boolean
}

export const BerthSelector: React.FC<Props> = ({
  berths,
  berthGroups,
  selectedBerthId,
  onChange,
  isBerthNotFound,
}) => {
  const hasGroups = berthGroups.length > 0

  // グループ選択state（デフォルトは未選択＝全バース表示）
  const [selectedGroupId, setSelectedGroupId] = useState<number | null>(null)

  // 表示するバースを決定
  const sortedGroups = [...berthGroups].sort((a, b) => a.groupOrder - b.groupOrder)
  const selectedGroup = sortedGroups.find((g) => g.id === selectedGroupId)

  const visibleBerths =
    hasGroups && selectedGroup
      ? berths.filter((b) => selectedGroup.berthIds.includes(Number(b.id)))
      : berths

  // グループ切り替え時、切り替え先グループの最初のバースを自動選択
  const handleGroupChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value
    if (value === '') {
      setSelectedGroupId(null)
      return
    }
    const groupId = Number(value)
    setSelectedGroupId(groupId)

    const group = sortedGroups.find((g) => g.id === groupId)
    if (group && group.berthIds.length > 0) {
      const firstBerthInGroup = berths.find((b) => group.berthIds.includes(Number(b.id)))
      if (firstBerthInGroup) {
        onChange(firstBerthInGroup.id)
      }
    }
  }

  if (berths.length === 0) {
    return (
      <div className={styles.selectorRow}>
        <div className={styles.emptyMessage}>バースがありません</div>
      </div>
    )
  }

  return (
    <div className={styles.sectionRoot}>
      <div className={styles.selectorRow}>
        {hasGroups && (
          <Select
            className={styles.dropdown}
            options={sortedGroups.map((g) => ({ label: g.groupName, value: g.id }))}
            value={selectedGroupId}
            onChange={handleGroupChange}
            placeholder="未選択"
          />
        )}
        <div className={styles.tabList}>
          {visibleBerths.map((b) => (
            <button
              key={b.id}
              className={`${styles.tab} ${b.id === selectedBerthId ? styles.tabActive : ''}`}
              onClick={() => onChange(b.id)}
            >
              {b.name}
            </button>
          ))}
        </div>
      </div>
      {isBerthNotFound && (
        <div className={styles.berthNotFoundMessage}>
          指定したバースIDが見つかりませんでした。上記からバースを選択してください。
        </div>
      )}
    </div>
  )
}
